<template>
  <v-layout class="ma-0">
    <div
      v-if="!hideIcon"
      class="mr-2"
    >
      <template v-if="detail.uid == user.uid">
        <img
          v-if="user.fbPicture"
          :src="user.fbPicture"
          class="avatar"
        >
        <span
          v-else
          class="info white--text avatar"
        >我</span>
      </template>
      <span
        v-else
        class="avatar"
      >
        <img
          v-if="detail.user?.settings?.avatar"
          :src="detail.user?.settings?.avatar | upyun"
          width="100%"
        >
        <img
          v-else-if="$store.state.project === 'mgb-pc'"
          src="/static/images/mgb-avatar.svg"
          class="avatar"
        >
        <svg
          v-else
          class="svg-icon"
          aria-hidden="true"
          style="width: 100%;height: 100%;"
        >
          <use xlink:href="#iconicon_qiaoyuan" />
        </svg>
      </span>
    </div>
    <v-flex
      class="pa-0"
      style="word-break: break-all;"
    >
      <div
        v-if="detail.uid == user.uid"
        v-html="$options.filters['nl2br'](detail.content)"
      />
      <div
        v-else-if="detail.content === '$[能寄嗎]'"
      >
        <div>
          您好，客服對於您這件商品也不是特別清楚，請在下方「能寄嗎？」的輸入框貼上品名或商品連結，點擊“放大鏡”進行查詢。
        </div>
        <!-- 您可使用「能寄嗎」進行查詢 -->
        <div style="width:315px">
          <ParcelCanPack />
        </div>
      </div>
      <div
        v-else-if="detail.content === '$[體積重量能寄嗎]'"
      >
        <div>
          您好，客服也不是特別清楚，請在下方輸入框輸入商品體積及重量進行查詢。
        </div>
        <div style="width:315px">
          <CanPackSizeContent
            inject
          />
        </div>
      </div>
      <div
        v-else-if="detail.content.indexOf('$[修改品類-') > -1"
      >
        <MessageUpdateCidRelcid :comment="detail" />
      </div>
      <div
        v-else-if="detail.content === '$[運費試算]'"
      >
        <div>
          <ShippingRatesCalcContent
            inject
            width="315"
          />
        </div>
      </div>
      <div
        v-else-if="detail.content === '$[輸入運單號]'"
      >
        <div style="width:315px">
          <InputTracnkingNo
            :parent="parent"
            :detail="detail"
            :disabled="replyDisabled"
            type="運單號"
            qustion="您好，請問是哪一個包裹單號呢？<br/>請以文字貼上包裹運單號，謝謝"
            @reload="$emit('reload')"
          />
        </div>
      </div>
      <div
        v-else-if="detail.content === '$[輸入訂單號]'"
      >
        <div style="width:315px">
          <InputTracnkingNo
            :parent="parent"
            :detail="detail"
            :disabled="replyDisabled"
            type="集運訂單號"
            qustion="您好，請問是哪一筆訂單呢？<br/>請以文字貼上集運訂單編號，謝謝"
            hint="英文字1碼+11碼數字"
            @reload="$emit('reload')"
          />
        </div>
      </div>
      <div
        v-else-if="detail.content === '$[輸入貼文按讚連結]' || detail.content === '$[輸入粉絲專頁按讚連結]' || detail.content === '$[輸入買即可粉絲專頁按讚連結]'"
      >
        <div style="width:315px">
          <InputFbLink
            :parent="parent"
            :detail="detail"
            :disabled="replyDisabled"
            @reload="$emit('reload')"
          />
        </div>
      </div>
      <div
        v-else-if="detail.content === '$[海快行事曆]'"
      >
        <CalendarSe
          inject
        />
      </div>
      <div
        v-else-if="detail.content === '$[空運行事曆]'"
      >
        <CalendarAir
          inject
        />
      </div>
      <div
        v-else-if="detail.content === '$[倉庫地址]'"
      >
        <div style="width:700px;">
          <Address
            inject
          />
        </div>
      </div>
      <div
        v-else-if="detail.content === '$[搜尋]'"
      >
        <div style="width:300px;">
          <SearchTool />
        </div>
      </div>
      <HtmlViwer
        v-else
        :content="detail.content"
      />
      <ImageListView
        :imageWidth="80"
        :images="detail.files"
        class="mt-2"
      />

      <div class="grey--text caption">
        {{ detail.createdAt }}
      </div>
    </v-flex>
  </v-layout>
</template>
<script>
import ParcelCanPack from '../../parcel/components/CanPack'
import CanPackSizeContent from '../../parcel/components/CanPackSizeContent'
import CalendarSe from '../../introduc/Se'
import CalendarAir from '../../introduc/Air'
import ShippingRatesCalcContent from '../../components/ShippingRatesCalcContent.vue'
import Address from '../../components/WarehousesTab'
import SearchTool from './SearchTool'
import ImageListView from './ImageListView'
import InputTracnkingNo from './InputTracnkingNo'
import InputFbLink from './InputFbLink.vue'
import MessageUpdateCidRelcid from './MessageUpdateCidRelcid.vue'

export default {
  components: {
    ImageListView,
    ParcelCanPack,
    CanPackSizeContent,
    ShippingRatesCalcContent,
    InputTracnkingNo,
    InputFbLink,
    CalendarSe,
    CalendarAir,
    Address,
    SearchTool,
    MessageUpdateCidRelcid,
  },
  props: {
    parent: Object,
    detail: Object,
    hideIcon: Boolean
  },
  computed: {
    user () {
      return this.$store.state.userData
    },
    replyDisabled () {
      return this.parent.banReply === 1 || this.parent.status === 'done'
    },
  }
}
</script>
<style lang="postcss" scoped>
.avatar {
  border-radius: 50%;
  overflow: hidden;
  display:block;
  line-height: 30px;
  height: 30px;
  width: 30px;
  text-align: center;
  font-size: 16px;
}
</style>
